import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const OnlineOrder: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--onlineorder')}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        d="M7.99237877,7 C8.54136451,4.51601003 9.81934039,3 11.89125,3 C13.9631596,3 15.2411355,4.51601003 15.7901212,7 L21,7 L21,19 L3,19 L3,7 L7.99237877,7 Z M9.02170596,7 L14.760794,7 C14.2840472,5.09415964 13.3158425,4 11.89125,4 C10.4666575,4 9.49845284,5.09415964 9.02170596,7 Z M7.81730088,8 L4,8 L4,18 L20,18 L20,8 L15.9651991,8 C16.0579258,8.69460001 16.10375,9.44763295 16.10375,10.25 L15.10375,10.25 C15.10375,9.43069483 15.0538957,8.67780156 14.9552648,8 L8.82723521,8 C8.72860427,8.67780156 8.67875,9.43069483 8.67875,10.25 L7.67875,10.25 C7.67875,9.44763295 7.72457421,8.69460001 7.81730088,8 Z M12.249281,14.2635143 L11.0190223,15.4340506 L11.0950514,10.3389089 L14.689125,13.9512329 L12.9910281,13.963829 L14.2242745,17.0162211 L13.4825274,17.3159064 L12.249281,14.2635143 Z"
        id="Online_Order_S"
        fill="#000000"
        fillRule="nonzero"
      />
    </g>
  </svg>
);

export default OnlineOrder;
